import type { User as _User } from "@/api/admin";
import type { WithFields, WithIncludes } from "@/api/jsonapi";
import { isHttpError, useGetOne } from "@mb-pro-ui/utils";

const fields = {
  users: ["username", "name", "email", "timezone", "ui-language", "urn", "org"],
  orgs: ["name"],
} as const;

const include = { org: {} } as const;

export type User = WithIncludes<
  WithFields<_User, typeof fields>,
  typeof include
>;

export default function useMe() {
  return useGetOne<User>("admin/users", "me", {
    include,
    fields,
    retry: true,
    retryDelay: (failureCount, error) => {
      if (isHttpError(error) && error.status === 401) {
        return 30000; // Retry after 30 seconds if not authenticated
      }
      return Math.min(1000 * 2 ** failureCount, 30000); // Exponential backoff
    },
  });
}
